import { getValueAndUnit } from 'polished';
import { remToPx } from '../remToPx/index.js';

var calculateLineHeight = function calculateLineHeight(fontSize) {
  if (!fontSize) {
    return undefined;
  }
  var _getValueAndUnit = getValueAndUnit(fontSize),
    amount = _getValueAndUnit[0],
    unit = _getValueAndUnit[1];
  var baseLineHeight = 24;
  if (unit && unit !== 'px' && unit !== 'rem') {
    return undefined;
  }
  var value = unit === 'rem' ? remToPx(amount) : amount;
  return Math.ceil(value / baseLineHeight) * (baseLineHeight / value);
};

export { calculateLineHeight };
